/* eslint-disable camelcase */
import React from "react"
import { useCustomName } from "hooks"
import { DEPARTMENT_KEY } from "utils/customNameHelpers"
import { auditShape } from "utils/propTypeShapes"
import { ACTIVE_STATUS, INACTIVE_STATUS } from "shared/lists/FacilityList/FacilityActiveStatusFilter"
import { AuditedUser } from "shared/audits"
import AuditChangeDetails from "../AuditChangeDetails"

const statusDescription = (audit, departmentNameInSentence) => {
  const { auditedChanges } = audit
  const { discarded_at = [] } = auditedChanges
  const statusChanged = Boolean(!!discarded_at[0] !== !!discarded_at[1])

  if (!statusChanged) return null

  const status = discarded_at[1] ? INACTIVE_STATUS : ACTIVE_STATUS

  return (
    <>
      set the status of {departmentNameInSentence}
      <span className="font-semibold"> {audit.department.name} </span>
      to
      <span className="font-semibold"> {status}</span>
    </>
  )
}

const modifiedDescription = (audit, departmentNameInSentence) => {
  const { auditedChanges, comment } = audit
  const { name } = auditedChanges

  return (
    <>
      modified {departmentNameInSentence}{name ? "" : <span className="font-semibold"> {audit.department.name}</span>} {comment}
    </>
  )
}

const DepartmentUpdated = ({ audit }) => {
  const { auditedChanges } = audit

  const { nameInSentence: departmentNameInSentence } = useCustomName(DEPARTMENT_KEY)

  const statusDesc = statusDescription(audit, departmentNameInSentence)

  return (
    <div>
      <span className="block">
        <AuditedUser audit={audit} /> { statusDesc || modifiedDescription(audit, departmentNameInSentence) }
      </span>
      {
        !statusDesc && (
          Object.entries(auditedChanges).map(([attribute, change]) => {
            if (typeof change[0] === "boolean" && typeof change[1] === "boolean") {
              change = change.map(String)
            }

            return (
              <AuditChangeDetails key={attribute} attribute={attribute} change={change} />
            )
          })
        )
      }
    </div>
  )
}

DepartmentUpdated.propTypes = {
  audit: auditShape.isRequired,
}

export default DepartmentUpdated
